'use strict';

export default class TimeUtils {
    static formatFromNow(timestamp, localize = (key) => { return key; }) {
        let diffSeconds = parseInt((Date.now() - timestamp * 1000) / 1000);
        let diffDays = Math.floor(diffSeconds / 86400);
        
        if (diffDays >= 1) {
            return diffDays + localize('day');
        }

        let diffHrs = Math.floor((diffSeconds % 86400) / 3600);

        if (diffHrs >= 1) {
            return diffHrs + localize('hour');
        }

        let diffMins = Math.floor(((diffSeconds % 86400) % 3600) / 60)

        if (diffMins >= 1) {
            return diffMins + localize('minute');
        }

        if (diffSeconds >= 20) {
            return diffSeconds + localize('second');
        }

        return localize('now');
    }
}



// WEBPACK FOOTER //
// ./src/javascript-classes/utils/time.js